<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper" style="height: calc(100vh - 50px)">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
      >
        <!-- 根据 sidebarRouters 路由，生成菜单 -->
        <sidebar-item
          v-for="(route, index) in sidebarRouters"
          :key="route.path  + index"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
// import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import router from "../../router";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["sidebarRouters","sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    // showLogo() {
    //   return this.$store.state.settings.sidebarLogo;
    // },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/index.vue